// extracted by mini-css-extract-plugin
export default {"container":"NowLine_container__CTMt-","svg":"NowLine_svg__n9IH-","line":"NowLine_line__znk+Q","text":"NowLine_text__tageU"};